module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "klickart-select",
    staticStyle: {
      "width": "97%"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("0 - " + _vm._s(_vm.$t('edit.canvas.all_steps')))]), _vm._v(" "), _vm._l((_vm.stepList), function(step) {
    return _c('option', {
      domProps: {
        "value": step.id,
        "selected": step.id === _vm.stepActive.id
      }
    }, [_vm._v(_vm._s(((_vm.stepDisplayPosition(step)) + " - " + (step.sanitized_title))))])
  })], 2)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-0559cc28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/StepSelect.vue
 ** module id = 748
 ** module chunks = 1
 **/